<template>
  <div>
    <div class="contentBody">
      <div class="contentBody__title">
        <span class="text">SNS連携</span>
      </div>
      <div class="account_content" v-if="relationSnsName">
        <ul class="account_content__list">
          <li class="section">
            <div class="section__box">
              <div class="section__box__left">
                <ul class="textcontents">
                  <li class="textcontents__item"><span class="value">{{ relationSnsName | setUpperCase }}:{{ relationSnsUserName || relationNickname || 'お名前を確認できませんでした' }}</span></li>
                </ul>
              </div>
              <div class="section__box__right">
                <button @click="deleteRelation">連携解除</button>
              </div>
            </div>
          </li>
        </ul>
        <div class="u-mg-l-2 u-mg-r-2 u-mg-t-4">
          <div class="line_text">
            <div class="line_text__sidebox"></div>
            <div class="line_text__text"><p>別のIDで連携</p></div>
            <div class="line_text__sidebox"></div>
          </div>
        </div>
        <div class="u-mg-t-2 u-mg-r-3 u-mg-l-3">
          <a class="btn btn-block u-mg-b-2" data-color="sns_line" href="https://us-central1-agarustore.cloudfunctions.net/generateLineLoginUri?relation=1">LINE連携</a>
          <button class="btn btn-block" data-color="sns_twitter" @click="addTwitterRelation">Twitter連携</button>
        </div>

        <div class="content_sub">
          <hr class="contentSeparatorSection gray-10 u-mg-t-4">
          <div class="formGroup__subText u-mg-t-2">
            <p>別のIDでSNS連携を行うと現在連携中のIDは自動的に解除されます。</p>
          </div>
        </div>
      </div>

      <div class="contentBody__section" v-else>
        <p>SNS連携を行うと次回ログイン時、SNSログインが可能になります。</p>
        <div class="u-mg-t-3">
          <a class="btn btn-block u-mg-b-2" data-color="sns_line" href="https://us-central1-agarustore.cloudfunctions.net/generateLineLoginUri?relation=1">LINE連携</a>
          <button class="btn btn-block" data-color="sns_twitter" @click="addTwitterRelation">Twitter連携</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import fetchAccountData from '@/utils/fetchAccountData'
import firebaselogin from './firebaselogin'

export default {
  name: 'account-edit',
  mixins: [firebaselogin],
  data() {
    return {
      loadingData: false,
      accountData: [],
      relationSnsUserName: '',
      relationSnsName: this.relationSns
    }
  },
  props: {
    relationSns: String,
    relationNickname: String,
    customToken: String
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      userAccount: state => state.account.profile,
      auth: state => state.auth.data
    }),
    ...mapGetters(['isLoggedIn']),
  },
  watch: {
    auth(){
      this.relationSnsName = this.auth.sns
      this.relationSnsUserName = this.auth.nickname
    }
  },
  mounted() {
    if(firebase.auth().currentUser){
      this.relationSnsUserName = firebase.auth().currentUser.displayName || ''
    }
    if (this.customToken) {
      this.addLineRelation()
    }
  },
  methods: {
    deleteRelation() {
      const data = {
        accessToken: this.accessToken
      }
      this.deleteFirebaseRelation(data)
      this.relationSnsName = ''
    },
    addTwitterRelation() {
      const provider = new firebase.auth.TwitterAuthProvider();
      firebase.auth().signInWithPopup(provider)
      .catch(error => {
        console.error(error.message)
      })
      .then(result => {
        let self = this
        const data = {
          nickname: result.user.displayName,
          email: result.user.providerData[0].email,
          uid: result.user.uid,
          sns: 'twitter',
          cpno: this.cpno,
          accessToken: this.accessToken
        }
        self.relationWithFirebaseUid(data)
      })
    },
    addLineRelation() {
      // console.log('linerelation')
      firebase.auth().signInWithCustomToken(this.customToken).then( result => {
        let self = this
        const data = {
          nickname: result.user.displayName,
          email: '',
          uid: result.user.uid,
          sns: 'line',
          cpno: this.cpno,
          accessToken: this.accessToken
        }
        self.relationWithFirebaseUid(data)
      }).catch(error => {
        // console.log(error)
      })
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SnsRelation.vue